import React, { useEffect, Fragment } from 'react'
import { Box, Button, Divider, List, ListItem, ListItemText, Typography } from '@material-ui/core'
import { isEmpty, last } from 'lodash'
import { Skeleton } from '@material-ui/lab'
import { Link } from 'react-router-dom'

import pluralize from 'pluralize'
import { publishViewedPotentialTeams } from '../../../util/events/teamsOnboardingEventPublishers'
import { profileRoute } from '../../../routes/routes'
import ButtonSubmit from '../../common/ButtonSubmit'

const NoTeam = ({ userEmail }) => {
  const emailDomain = last(userEmail.split('@'))
  return (
    <>
      <Box marginBottom={3}>
        <Typography variant="body2">
          We couldn&apos;t find any existing teams at your company based on your {emailDomain}
          &nbsp;email.
        </Typography>
      </Box>
      <Button component={Link} role="a" to={profileRoute.path} color="primary" variant="outlined">
        Edit your email address
      </Button>
    </>
  )
}

const PotentialTeams = ({ userEmail, teams, loading, onJoin, submitting }) => {
  useEffect(() => {
    publishViewedPotentialTeams()
  }, [])

  if (loading) {
    return <Skeleton data-testid="loading" height="180px" />
  }

  if (isEmpty(teams)) {
    return <NoTeam userEmail={userEmail} />
  }

  return (
    <List>
      {teams.map((team, key) => (
        <Fragment key={team.accountId}>
          <ListItem>
            <ListItemText
              primary={team.name}
              secondary={pluralize('member', team.totalMembers, true)}
            />
            <ButtonSubmit
              onClick={() => onJoin(team.accountId, team.name)}
              color="primary"
              variant="outlined"
              submitting={submitting}
            >
              Join
            </ButtonSubmit>
          </ListItem>
          {key !== teams.length - 1 && <Divider data-testid="divider" />}
        </Fragment>
      ))}
    </List>
  )
}

export default PotentialTeams
